import { _ as _isPrototype } from "./auth-service-tools1222.js";
import { _ as _nativeKeys } from "./auth-service-tools1223.js";
var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys;
export { _baseKeys as _ };